<template>
  <div class="collectList">
    <ul v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10" class="lists">
      <li @click="gotodetail(item.activityId)"
        v-for="(item,index) in collectionList"
        :key="item.activityId"
        class="collectItem">
        <div class="infowarp">
          <div class="tit ellipse">{{item.activityName}}</div>
          <div class="time">时间：{{item.activityTime}}</div>
          <div class="addr">地点：{{item.activityPlace}}</div>
        </div>
        <div class="lbwarp" >
          <img :src="item.picUrl" alt="" class="imgmain">
          <!--<mt-swipe  :show-indicators="false" :auto="0">
            <mt-swipe-item><img src="../assets/newimg.png" alt="" class="imgmain"></mt-swipe-item>
            <mt-swipe-item><img src="../assets/newimg.png" alt="" class="imgmain"></mt-swipe-item>
            <mt-swipe-item><img src="../assets/newimg.png" alt="" class="imgmain"></mt-swipe-item>
          </mt-swipe>-->
           <!-- 轮播图 -->
          <!-- <div class="swiper-container" >
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img src="../assets/newimg.png" alt="" class="imgmain">
              </div>
              <div class="swiper-slide">
                <img src="../assets/newimg.png" alt="" class="imgmain">
              </div>
              <div class="swiper-slide">
                <img src="../assets/newimg.png" alt="" class="imgmain">
              </div>
            </div>
          </div> -->
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import { Indicator } from 'mint-ui';
  import {api} from '../global/api';
  import Swiper from 'swiper';
  import 'swiper/dist/css/swiper.min.css';
  export default {
    name: "activitypublic",
    data(){
      return {
        collectionList:[],
        loading:true,
        size:2,
        currentPage:1
      }
    },
    mounted(){
      this.getCollections(false);
      let that = this;
      setTimeout(function(){
        for(var i=0;i<that.collectionList.length;i++){
          var mySwiper = new Swiper(".lb"+i+" .swiper-container", {
                loop:false,
                slidesPerView:2.2,
                spaceBetween:between()/2,
              })
        }
      },10)
    },
    methods: {
       setClass(key) {
            let obj = {}
            obj[`lb${key}`] = true
            return obj
        },

      loadMore() {
        // 多次加载数据
          setTimeout(() => {
            this.currentPage ++;
            this.getCollections(true);
          }, 1000);
      },
      gotodetail(id) {
        this.$router.push({
          path: 'publicDetail',
          query: {id: id}
        });
      },
      getCollections(flag) {
        Indicator.open({text: '加载中...', spinnerType: 'fading-circle'});
        const params = {activityCategory: 1,size:this.size,currentPage:this.currentPage};
        this.$http.get(api.activity, {params:params}).then(response => {
          let { success,data }=response.data;
          if(success === 1){
            Indicator.close();
            if(flag){
              // 多次加载数据
                this.collectionList = this.collectionList.concat(data);
                if(data.length == 0){
                  this.loading = true;
                }else{
                  this.loading = false;
                }
            }else{
              // 第一次加载数据
              this.collectionList = data;
              this.loading = false;
            }
            }else{
              console.log("接口异常");
            }
          }, response => {
            console.log("请求失败了");
          })
        },
    }
  }
</script>

<style lang="scss" scoped>
  .collectList{
    padding: 0rem .75rem 1rem;
    margin-bottom: 1.5rem;
  }
  .lists{
    margin: 0;
  }

  .collectItem{
    margin-top: 0;
    margin-bottom: .5rem;
    .infowarp{
      .tit{
        font-size: 0.7rem;
        color: #333333;
      }
      .time{
        margin-top: 0.2rem;
        font-size: 0.65rem;
        color: #999999;
      }
      .addr{
         margin-top: 0.2rem;
        font-size: 0.65rem;
        color: #999999;
      }
    }
    .lbwarp{
        margin-top: 0.5rem;
        padding-bottom: 0.5rem;
        border-bottom: 1px solid #D8D8D8;
        width: 17.25rem !important;
        height: 12.95rem !important;
        position: relative;
        img{
              display: inline-block;
              width: 17.25rem;
              height: 12.95rem;
              border-radius: 0.5rem;
            }
        .swiper-container{

          .swiper-slide{
            width: 16rem !important;
            height: 12.4rem !important;
            .imgmain{
              width: 16rem;
              height: 12.4rem;
            }
          }

        }

    }
  }

</style>



// WEBPACK FOOTER //
// src/view/activitypublic.vue